/**
 * Lecture du corps d'un JWT — sans vérification de signature.
 *
 * Ne sert QU'À lire ce que le fournisseur d'identité vient de nous remettre
 * (scopes, claims d'affichage). Aucune décision de sécurité n'en dépend :
 * l'API revérifie la signature de chaque jeton côté serveur.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> {
  const segment = token.split(".")[1];
  if (!segment) throw new Error("Malformed token");
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  const json = new TextDecoder().decode(
    Uint8Array.from(atob(padded), (ch) => ch.charCodeAt(0)),
  );
  return JSON.parse(json) as Record<string, unknown>;
}

/** Le scope qu'exigent les opérations « self-service » sur les passkeys. */
export const ADMIN_SCOPE = "aws.cognito.signin.user.admin";

/** Ce jeton d'accès permet-il d'enrôler, lister ou retirer un passkey ? */
export function hasAdminScope(accessToken: string | undefined): boolean {
  if (!accessToken) return false;
  try {
    const scope = decodeJwtPayload(accessToken).scope;
    return typeof scope === "string" && scope.split(" ").includes(ADMIN_SCOPE);
  } catch {
    return false;
  }
}
